module.exports = __webpack_public_path__ + "img/61.dd5fe4f0.png";